import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/alocacao-agenda-profissional`;
export const alocarAgenda = async (agenda) => {
  return await axios.post(`${httpUrl}/alocar-agenda`, agenda).then((response) => response);
};

export const getAgendaAlocacoes = async (cpf) => {
  return await axios.get(`${httpUrl}/list/cpf/${cpf}`).then((response) => response);
};

export const excluir = async (id) => {
  return await axios.delete(`${httpUrl}/delete/${id}`).then((response) => response);
};

export const getEventsAgenda = async (cpf, numSemana) => {
  return await axios.get(`${httpUrl}/events/cpf/${cpf}?numSemana=${numSemana}`).then((response) => response);
};

export const getAllEvents = async (cpf, numSemana) => {
  return await axios.get(`${httpUrl}/events-com-agendamentos/cpf/${cpf}?numSemana=${numSemana}`).then((response) => response);
};

export const gravarConsulta = async (form) => {
  return await axios.post(`${httpUrl}/marcar-consulta`, form).then((response) => response);
};

export const getConsulta = async (id) => {
  return await axios.get(`${httpUrl}/consulta/${id}`).then((response) => response);
};
